<nav mat-tab-nav-bar>
  <a mat-tab-link
     *ngFor="let link of tabLinks"
     [routerLink]="link.path"
     routerLinkActive #rla="routerLinkActive"
     [active]="rla.isActive">
    {{link.label}}
  </a>
</nav>
<router-outlet></router-outlet>
<style>
  .mat-tab-links {
    background-color: #fff;
  }
</style>